import { PrescriptionStatusType } from "common/enums/PrescriptionStatusTypeEnum";

export interface PrescriptionType {
  readonly id: number;
  readonly subContactsIDs: Array<number>;
  readonly recipeId: string;
  readonly recipeStatus: PrescriptionStatusType;
  readonly helenaDate?: Date;
  readonly pdf?: string;
  readonly dto?: object;
}

export class Prescription implements PrescriptionType {
  readonly id: number;
  readonly subContactsIDs: Array<number>;
  readonly recipeId: string;
  readonly recipeStatus: PrescriptionStatusType;
  readonly helenaDate?: Date;
  readonly pdf?: string;

  constructor(data?: PrescriptionType) {
    this.id = -1;
    this.subContactsIDs = [];
    this.recipeId = "";
    this.recipeStatus = PrescriptionStatusType.NOT_IN_RECIPE;
    if (data) {
      Object.assign(this, data);
    }
  }
}
